import api from 'api/apiInstance';

export function clientCaseRiskAssessmentsLastApi(path: string) {
  return {
    path,
    GET: () => api.get(path),
  };
}
